import { render, staticRenderFns } from "./ExtraColumn.vue?vue&type=template&id=1b503bf0&scoped=true"
import script from "./ExtraColumn.vue?vue&type=script&lang=js"
export * from "./ExtraColumn.vue?vue&type=script&lang=js"
import style0 from "./ExtraColumn.vue?vue&type=style&index=0&id=1b503bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b503bf0",
  null
  
)

export default component.exports